var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { nl2br, targetBlankifyLinks } from '../../lib/helpers';
import { strings } from '../../lib/localization';
export var ConsentDialog = function (_a) {
    var localizationFormatValues = _a.localizationFormatValues, consent = _a.consent, onApprove = _a.onApprove, onClose = _a.onClose;
    var approveButtonRef = useRef(null);
    var text = strings.formatString(consent.body, localizationFormatValues);
    var brandingContent = {
        __html: nl2br(targetBlankifyLinks(text)),
    };
    useEffect(function () {
        var keyDownListener = function (e) {
            if (e.key === 'Escape') {
                onClose();
            }
        };
        window.addEventListener('keydown', keyDownListener);
        return function () {
            window.removeEventListener('keydown', keyDownListener);
        };
    }, []);
    var handleBackKeyDown = function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onApprove();
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: 'consentDialogOverlay', onClick: onClose }, void 0), _jsxs("div", __assign({ className: 'consentDialog', role: "dialog", "aria-describedby": "imboxBranding" }, { children: [_jsx("div", { className: 'consentContent', dangerouslySetInnerHTML: brandingContent, id: "imboxBranding" }, void 0), _jsx("button", __assign({ ref: approveButtonRef, className: "consentButton accentSecondaryButton", role: "button", tabIndex: 0, onKeyDown: handleBackKeyDown, onClick: onApprove }, { children: consent.button }), void 0)] }), void 0)] }, void 0));
};
